export default __webpack_public_path__ + "static/media/shape3.7aec497d.svg";